import { Transaction } from '../types';
import { isPenceSterling } from './quoteNormalization';

const normalizeTransactionUnitPrice = (unitPrice: number, tx: Transaction): number => {
    if (!Number.isFinite(unitPrice) || unitPrice <= 0) return 0;

    const priceCurrency = String(tx.originalPriceCurrency || tx.priceCurrency || '').trim().toUpperCase();
    const normalized = isPenceSterling({
        currency: priceCurrency,
        rawCurrency: priceCurrency,
        exchange: tx.exchange,
        price: unitPrice,
    })
        ? unitPrice * 0.01
        : unitPrice;

    return Number.isFinite(normalized) ? normalized : unitPrice;
};

const convertTotalToPriceCurrency = (tx: Transaction): number | null => {
    const total = Number(tx.total ?? tx.amount);
    const fxRate = Number(tx.fxRate ?? tx.originalExchangeRate);
    const totalCurrency = String(tx.totalCurrency || tx.currency || '').trim().toUpperCase();
    const priceCurrency = String(tx.originalPriceCurrency || tx.priceCurrency || '').trim().toUpperCase();

    if (!Number.isFinite(total) || total <= 0) return null;
    if (!priceCurrency || !totalCurrency || priceCurrency === totalCurrency) return total;
    if (!Number.isFinite(fxRate) || fxRate <= 0) return null;

    if (totalCurrency === 'GBP' && priceCurrency === 'USD') return total * fxRate;
    if (totalCurrency === 'USD' && priceCurrency === 'GBP') return total / fxRate;
    return total * fxRate;
};

export const resolveTransactionUnitPrice = (tx: Transaction): number => {
    const quantity = Number(tx.quantity || tx.shares || 0);
    if (!Number.isFinite(quantity) || quantity <= 0) return 0;

    const directPrice = Number(tx.originalPricePerShare ?? tx.pricePerShare ?? tx.price);
    if (Number.isFinite(directPrice) && directPrice > 0) {
        return normalizeTransactionUnitPrice(directPrice, tx);
    }

    const convertedTotal = convertTotalToPriceCurrency(tx);
    if (convertedTotal && convertedTotal > 0) {
        return normalizeTransactionUnitPrice(convertedTotal / quantity, tx);
    }

    const rawAmount = Number(tx.amount);
    if (Number.isFinite(rawAmount) && rawAmount > 0) {
        return normalizeTransactionUnitPrice(rawAmount / quantity, tx);
    }

    return 0;
};
